import React, { useEffect, useRef } from 'react';

const JitsiMeetComponent = ({ roomName, displayName, onCallEnd, jwtToken }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!window.JitsiMeetExternalAPI) {
            alert("Jitsi Meet API not loaded");
            return;
        }

        const domain = "8x8.vc";
        const fullRoomName = `vpaas-magic-cookie-efa899d14e974e4a95a4311e9123af00/${roomName}`;

        const options = {
            roomName: fullRoomName,
            parentNode: containerRef.current,
            userInfo: {
                displayName
            },
            jwt: jwtToken,
            width: "100%",
            height: "100%",
            configOverwrite: {
                startWithAudioMuted: false,
            },
            interfaceConfigOverwrite: {
                SHOW_JITSI_WATERMARK: false,
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'chat', 'desktop', 'fullscreen', 'hangup'
                ],
            }
        };

        const api = new window.JitsiMeetExternalAPI(domain, options);

        api.addEventListener("readyToClose", () => {
            if (typeof onCallEnd === 'function') {
                onCallEnd();
            }
        });

        return () => {
            api.dispose();
        };
    }, [roomName, displayName, onCallEnd]);

    return (
        <div className="w-full h-[88vh] border rounded-xl overflow-hidden">
            <div ref={containerRef} className="w-full h-full" />
        </div>
    );
};

export default JitsiMeetComponent;
